<template>
    <div class="customer-confirmation" :class="{'noProgressBar': isAccountStatusValid}">
      <!-- 加载成功 -->
      <template v-if="isloading == 2">
        <Progress progress="99" v-if="!isAccountStatusValid"></Progress>
        <div class="title">{{ $t('customerConfirmation.c000001') }}：</div>
        <!-- 首开协议 -->
        <template v-if="!isAccountStatusValid">
          <checkboxGroup class="agreement" v-model="agreementResult">
            <checkbox class="item" shape="square" :name="1" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("agreement.electronic_sign.checkbox_label_1") }}
            </checkbox>
            <checkbox class="item" shape="square" :name="2">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("agreement.electronic_sign.checkbox_label_2_prev") }}
              <span class="highlight" @click.stop="openAgreement(1)">{{$t("agreement.electronic_sign.checkbox_label_2_middle") }}</span>
              {{ $t("agreement.electronic_sign.checkbox_label_2_next") }}
            </checkbox>
            <checkbox class="item" shape="square" :name="3" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("agreement.electronic_sign.checkbox_label_3") }}
            </checkbox>
            <checkbox class="item" shape="square" :name="4" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              <span>{{$t("agreement.electronic_sign.checkbox_label_4_prev")}}</span>
              <span class="highlight" @click.stop="openAgreement(2)">{{$t("agreement.electronic_sign.checkbox_label_4_middle")}}</span>
              <span>{{$t("agreement.electronic_sign.checkbox_label_4_middle_name") }}</span>
              <span class="highlight" @click.stop="openAgreement(5)">{{$t("agreement.electronic_sign.checkbox_label_4_middle1") }}</span>
              <span>{{$t("agreement.electronic_sign.checkbox_label_4_next")}}</span>
            </checkbox>
            <checkbox class="item" shape="square" :name="5" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              <span>{{$t("agreement.electronic_sign.checkbox_label_5_prev")}}</span>
              <span class="highlight" @click.stop="openAgreement(4)">{{$t("agreement.electronic_sign.checkbox_label_5_middle")}}</span>
              <span>{{$t("agreement.electronic_sign.checkbox_label_5_next")}}</span>
            </checkbox>
            <!-- 方框 -->
            <div class="tips">{{ $t("agreement.electronic_sign.desc") }}</div>
            <checkbox class="item" shape="square" :name="6" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("agreement.electronic_sign.checkbox_label_5") }}
            </checkbox>
            <checkbox class="item" shape="square" :name="7" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("agreement.electronic_sign.checkbox_label_6") }}
            </checkbox>
            <checkbox class="item" shape="square" :name="8" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t("agreement.electronic_sign.checkbox_label_7") }}
            </checkbox>
            <checkbox class="item boldText" shape="square" :name="9" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ signatureConsentText }}
            </checkbox>
          </checkboxGroup>
          <!-- 签名照 加开不展示 -->
          <div class="signature" >
              <div class="title">{{ $t('customerConfirmation.c000002') }}</div>
              <div class="box" @click="goToSign">
                  <img v-if="signImage" class="signImage" :src="signImage" />
                  <div v-else class="tips">
                    <span class="text">{{ $t('customerConfirmation.c000003') }}</span>
                    <img class="icon" src="../../../assets/images/open-account/Groupx@3x.png" />
                  </div>
              </div>
          </div>
        </template>
        <!-- 加开 -->
        <template v-else>
          <checkboxGroup class="agreement" v-model="agreementResult">
            <checkbox class="item" shape="square" :name="1" v-if="pending_profile == 1">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t('customerConfirmation.c000007') }}
            </checkbox>
            <checkbox class="item" shape="square" :name="2" v-else>
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ $t('customerConfirmation.c000006') }}
            </checkbox>
            <p class="text">{{ $t('customerConfirmation.c000008') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000009') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000010') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000011') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000012') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000013') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000014') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000015') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000016') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000017') }}</p>
            <p class="text">{{ $t('customerConfirmation.c000018') }}</p>
            <checkbox class="item lastItem" shape="square" :name="9" >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ pending_profile == 1 ? $t('customerConfirmation.c000019') : $t('customerConfirmation.c000022') }}
            </checkbox>
          </checkboxGroup>
        </template>
        <!-- 按钮组 -->
        <nav-buttons
            :nextText="$t('openAccount.t000094')"
            navigationType="back"
            :disabled="isDisabled"
            @on-next="submitForm"
        />
      </template>
      <!-- 加载中 -->
      <template v-else-if="isloading == 1">
        <div class="loading">
          <Loading size="24px" type="spinner" vertical>{{ $t("common.loading_text") }}</Loading>
        </div>
      </template>
      <!-- 验证登录密码弹窗 -->
      <van-dialog v-model="displayPwdDialog"
        class="check-password-dialog"
        :title="$t('fail_reason.checkPassword')" show-cancel-button
        :before-close="handleBeforeClose">
        <div class="verifyLoginPassword">
          <Field class="input" v-model="checkPassword" :type="eyeIsOpen ? 'text' : 'password'" >
            <template #button>
              <template v-if="!eyeIsOpen">
                <img
                  src="@/assets/images/open-account/light_close.png"
                  class="eye lightClose"
                  @click="eyeSwitch"
                >
                <img
                  src="@/assets/images/open-account/dark_close.png"
                  class="eye darkClose"
                  @click="eyeSwitch"
                >
              </template>
              <template v-else>
                <img
                  src="@/assets/images/open-account/light_open.png"
                  class="eye lightOpen"
                  @click="eyeSwitch"
                >
                <img
                  src="@/assets/images/open-account/dark_open.png"
                  class="eye darkOpen"
                  @click="eyeSwitch"
                >
              </template>
            </template>
          </Field>
        </div>
      </van-dialog>

      <!-- 密码错误弹窗 -->
      <van-dialog v-model="displayPwdError" :confirm-button-text="errMsg.confirmText" @confirm="confirmPwdError">
        <div class="showPasswordErrorDialog">
          <div v-html="errMsg.h5"></div>
        </div>
      </van-dialog>
    </div>
  </template>

  <script>
  import { Checkbox, CheckboxGroup, Toast, Dialog, Field, Loading } from 'vant';
  import navButtons from '../components/navButtons.vue'
  import Progress from '../components/Progress.vue'
  import * as Sentry from "@sentry/vue";
  import CheckNone from '@/assets/images/open-account/check_none.png'
  import Checkd from '@/assets/images/open-account/check.png'
  import { openAgreementPdf } from '../utils/resolveAgreementPdf'

  export default {
    components: {
      Checkbox,
      CheckboxGroup,
      Toast,
      navButtons,
      Progress,
      [Dialog.Component.name]: Dialog.Component,
      Field,
      Loading
    },
    data() {
      this.autograph_date = '';    // 签名日期
      return {
        CheckNone,
        Checkd,
        pending_profile: null,    // 待处理资料标识：1=有更改
        agreementResult: [],      // 勾选结果
        signImage: '',   // 签名照
        displayPwdDialog: false,      // 控制密码弹窗显示
        isMainlandNationality: false, // step 3-2 nationality_code == 1
        checkPassword: '',          //  密码输入
        eyeIsOpen: false,        // 是否明文显示密码
        displayPwdError: false,      // 是否显示密码错误弹窗
        errMsg: {},        // 密码错误显示数据
        account_status: 0,     // 是否加开
        isloading: 1, // 1 加载中 || 2加载成功,
        openServerData: '',
        change: '', // 是不是 去修改 进入的
      };
    },
    computed: {
      isDisabled() {
        if (this.isAccountStatusValid) {
          // 加开：只校验实际渲染出来的勾选框
          const changeName = this.pending_profile == 1 ? 1 : 2;
          const hasAllRequired = [changeName, 9].every(element => this.agreementResult.includes(element));
          return !hasAllRequired;
        }
        // 首开
        const requiredElements = [1, 2, 3, 4, 5, 8, 9];
        const hasAllRequired = requiredElements.every(element => this.agreementResult.includes(element));
        return !hasAllRequired || this.signImage == '';
      },
      isAccountStatusValid() {
        const invalidStatuses = [0, 2, 3, 21];
        return this.openServerData?.process_id == 4 || !invalidStatuses.includes(this.account_status);
      },
      signatureConsentText() {
        if (this.isMainlandNationality) {
          return this.$t("agreement.electronic_sign.checkbox_label_8_with_mainland");
        }
        return this.$t("agreement.electronic_sign.checkbox_label_8");
      }
    },
    mounted() {
      this.change = this.$route.query.change;
      this.init();
    },
    methods: {
      init() {
        this.getCachedData();
      },
      resolveMainlandNationality(process_info) {
        try {
          const configData = process_info?.["3-2"]?.config_data;
          if (!configData) {
            this.isMainlandNationality = false;
            return;
          }
          const parsed =
            typeof configData === "string" ? JSON.parse(configData) : configData;
          this.isMainlandNationality = parsed?.nationality_code == 1;
        } catch (error) {
          this.isMainlandNationality = false;
          console.log("[customerConfirmation] 解析国籍失败:", error);
        }
      },
      // 获取数据
      async getCachedData() {
          // 定义默认值
          const defaultAgreementResult = [1, 2, 3, 4, 5, 8, 9];
          try {
              const { account_status, process_info, get_open_account_info, faile_open_info_record_id, pending_profile } = await this.$apis.accountSituationV2({ step_code: '1,3-2,customer_confirmation,15,extra_data,open_server', showLoading: true });
              this.account_status = account_status;
              this.faile_open_info_record_id = faile_open_info_record_id;
              this.pending_profile = pending_profile;
              this.openServerData = process_info?.open_server
              this.resolveMainlandNationality(process_info);
              let selectedProcessInfo = '',
                  agreementResult = [];
              // 获取加开数据
              if ( this.isAccountStatusValid ) {
                selectedProcessInfo = process_info?.['customer_confirmation'];
              } else {
                selectedProcessInfo = process_info?.[15];     // 获取首开数据
              }
              const configData = JSON.parse(selectedProcessInfo?.config_data || '{}');
              this.signImage = configData.signImage || ''; // 获取签名照
              this.autograph_date = configData.autograph_date || '';      // 签名日期
              if (Array.isArray(configData.agreementResult)) { // 检查解析后的数据是否为非空数组
                  agreementResult = configData.agreementResult;
              }
              // 如果没有从接口获取到数据，则使用默认值
              if (agreementResult.length == 0) {
                  agreementResult = defaultAgreementResult;
              }
              this.agreementResult = agreementResult;
              this.handleProcessId(process_info, get_open_account_info);
              this.isloading = 2;
              this.$nextTick(()=>{
                this.setScrollTop();
              })
          } catch (error) {
              this.agreementResult = defaultAgreementResult; // 在发生错误时，使用默认值
              this.isloading = 2;
              this.reportError('客户确认开户获取数据错误', error)
              this.$nextTick(()=>{
                this.setScrollTop();
              })
          }
      },
      setScrollTop(){
        const customerConfirmationScrollTop = localStorage.getItem('customerConfirmationScrollTop');
        const appDom = document.getElementById('app');
        setTimeout(()=>{
          appDom.scrollTop = customerConfirmationScrollTop;
          setTimeout(()=>{
            localStorage.removeItem('customerConfirmationScrollTop')
          },10)
        },30)
      },
      handleProcessId(process_info, get_open_account_info) {
        // 加开就默认是4，首开从第一步取数据
        this.process_id = this.isAccountStatusValid
          ? 4
          : process_info[1]?.process_id || get_open_account_info?.open_status;
      },
      // 提交
      async submitForm() {
        if ( this.isDisabled ) return false;
        // 加开的情况下需要验证登录密码
        if ( this.isAccountStatusValid ) {
          this.displayPwdDialog = true;
        } else {
          this.loading = Toast.loading({
            duration: 0,
            forbidClick: true,
            loadingType: "spinner",
            message: this.$t("common.loading_text")
          });
          this.submitAccountOpening();      // 首次开户直接提交开户申请
        }

      },
      // 提交签名照换取地址
      async submitSignatureImage() {
        const file = this.dataURLtoFile(this.signImage, 'signature');
        const params = new FormData();

        params.append('file', file);
        params.append('put_dir', 'gygjqh_autograph');

        try {
          const res = await this.$apis.uploadFile(params);
          return res;
        } catch (error) {
          this.reportError('上传签名图片失败', error)
        }
      },
      dataURLtoFile(dataurl, filename) {
        const [header, body] = dataurl.split(',');
        const mime = header.match(/:(.*?);/)[1];
        const byteString = atob(body);
        const uint8Array = new Uint8Array(byteString.length);

        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }

        return new File([uint8Array], filename, { type: mime });
      },
      // 开户申请提交（每个异步加一个try，报错的情况不影响下一步）
      async submitAccountOpening() {
        // 提交本地数据
        try {
          await this.reportData(2);
        } catch (error) {
          this.reportError('reportData提交本地数据失败', error)
        }
        // 开户申请提交
        try {
          // 这里少了一个加开的  加开也是直接 走 if中的提交
          
          if( this.isAccountStatusValid ){
            const res = await this.$apis.saveAccountAccountSecondSaveApi({
              open_info_record_id: this.faile_open_info_record_id
            })
            if(res.code && res.msg){
              this.loading && this.loading.clear();
              this.$toast(res.msg);
            }else{
              let path = "/open-account/submitAccount";
              if(this.$route.query.change == 1){
                path = "/open-account/home";
              }
              this.loading && this.loading.clear();  // 在路由跳转前清除loading
              this.$router.push(path);
            }
          }else{
            if(this.$route.query.change == 1){
              this.loading && this.loading.clear();  // 在路由跳转前清除loading
              this.$router.push({ path: '/open-account/home' });
            }else{
              const res = await this.$apis.openAccountSubmission({ process_id: this.process_id });
              if(res.code && res.msg){
                this.loading && this.loading.clear();
                this.$toast(res.msg);
              }else{
                let path = "/open-account/submitAccount";
                this.loading && this.loading.clear();  // 在路由跳转前清除loading
                this.$router.push(path);
              }
            }
          }
        } catch (error) {
          this.loading = null;
          this.reportError('开户申请提交失败', error)
        }
      },
      // 上报数据
      async reportData(type = 1) {
        const query = {
          process_id: this.process_id, step_code: 15, step_order: 15,
          config_data: {
            agreementResult: this.agreementResult,
            signImage: this.signImage,
            autograph_date: this.autograph_date
          }
        };
        // 加开的情况下修改key
        if ( this.isAccountStatusValid ) {
          query.step_code = 'customer_confirmation';
          query.step_order = 6;
          // 加开情况下，额外提供给后端，方便他操作业务
          query.config_data.customer_confirmation = {
            customer_commitment: {
              id: this.pending_profile == 1 ? 2 : 1,
              value: 1
            }
          }
        }
        // 首开提交开户的情况下上传签名照换地址
        if ( type == 2 && !this.isAccountStatusValid ) {
          const res = await this.submitSignatureImage();
          if ( res && res.content ) {
            query.config_data.autograph_img = res.content;
          }
        }
        await this.$apis.supplementSaveApi(query);
      },
      // 去签名页
      async goToSign() {
        const customerConfirmationScrollTop = document.getElementById('app').scrollTop;
        localStorage.setItem('customerConfirmationScrollTop', customerConfirmationScrollTop);
        await this.reportData();
        this.$router.push('/open-account/signaturePage');
      },
      // 打开协议 PDF（enum 绝对地址）
      openAgreement(type) {
        openAgreementPdf(type);
      },
      eyeSwitch() {
        this.eyeIsOpen = !this.eyeIsOpen;
      },
      // 加开输入交易密码后的确认操作
      async handleConfirm(done = null) {
        if ( this.checkPassword == '' ) {
          Toast(this.$t('fail_reason.checkPasswordTips'));
          done(false);
          return false;
        }
        try {
          let res = await this.$apis.checkPasswordFail({ password: this.checkPassword });
          // 如果res为null处理
          if (!res || res.code == 'undefined') {
            this.reportError('开户密码校验返回的数据有误！');
            done(false);
            return false;
          }
          // 输入密码错误
          if (res.code === 100173 || res.code === 100174) {
            const errorMessages = {
              100173: this.$t('passwordErrorPrompt.tryAgain'),
              100174: this.$t('passwordErrorPrompt.set'),
            };
            res.data.err_msg['confirmText'] = errorMessages[res.code];
            res.data.err_msg['code'] = res.code;
            this.errMsg = res.data.err_msg;
            this.displayPwdError = true;
            done(false);          // 不关闭登录密码弹窗
          } else {
            await this.submitAccountOpening();    // 输入正确触发提交
            this.displayPwdDialog = false;
            done();       // 取消弹窗
          }
        } catch (error) {
          
          this.reportError('输入开户密码出问题', error)
        }
      },
      // 密码错误次数上限了，去重新设置密码
      async confirmPwdError() {
        if ( this.errMsg.code == 100174 ) {
          await this.reportData();        // 离开之前存一份数据
          this.$router.push({ path: "/login-password-forget" });
        }
      },
      handleClose() {
        this.checkPassword = '';
        this.eyeIsOpen = false;
      },
      async handleBeforeClose(action, done) {
        // 取消直接关闭弹窗
        if ( action != 'confirm' ) {
          this.handleClose();
          done()
          return false;
        }
        // 确认带上done，作用是控制弹窗是否关闭 done(false)不允许关闭
        this.handleConfirm(done);
      },
      // 监控上报
      reportError(title, error) {
        Sentry.captureMessage(title, {
          level: "warning",
          extra: {
            url: '/open-account/customerConfirmation',
            error,
            account_status: this.isAccountStatusValid ? '加开' : '首开',
            process_id: this.process_id
          },
          fingerprint: [Date.now()]
        });
      },
    },
  };
  </script>

  <style lang="less" scoped>
  .customer-confirmation {
    padding: 92px 34px 200px;
    min-height: 100vh;
    &.noProgressBar {
      padding-top: 22px !important;
    }
    .title {
      font-size: 36px;
      font-weight: 500;
      color: #17161c;
      line-height: 46px;
      // white-space: nowrap;
      margin-bottom: 22px;
    }
    .agreement {
      .item {
        display: flex;
        margin-bottom: 20px;
        &.lastItem {
          margin-top: 10px;
          .editColor {
            color: #FD2626;
          }
        }
        .highlight {
          color: #007bff; /* 高亮颜色 */
          cursor: pointer;
        }
        &.boldText {
          font-weight: bold;
        }
      }
      .tips {
        width: 686px;
        // height: 504px;
        background: #f6f7fa;
        border-radius: 24px;
        padding: 32px 20px;
        box-sizing: border-box;
        font-size: 28px;
        color: #17161c;
        margin-bottom: 16px;
        .text {
          text-align: center;
        }
      }
      .text {
        padding: 10px 0;
        line-height: 45px;
        color: #17161c;
      }
    }
    .signature {
      margin-top: 40px;
      .title {
        font-size: 32px;
        font-weight: bold;
        color: #000000;
      }
      .box {
        width: 686px;
        height: 260px;
        border: 2px dashed rgba(23,22,28,0.45);
        border-radius: 8px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .signImage {
          height: 100%;
          transform: rotate(-90deg);
        }
        .tips {
          .text {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            color: #747377;
            z-index: 10;
          }
          .icon {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 132px;
            height: 146px;
            opacity: 0.6;
          }
        }
      }
    }
    .loading {
      margin-top: 200px;
    }
    .verifyLoginPassword {
      margin: 20px;
      .input {
        height: 80px;
        font-size: 28px;
        border: 1px solid #F3F3F3;
        border-radius: 16px;
        /deep/ .van-field__button {
          display: flex;
          align-items: center;
        }
      }
      .eye {
        width: 50px;
        height: 50px;
        display: none;
      }
    }
    /deep/ .showPasswordErrorDialog {
      margin: 70px 0 32px;
      .box-row {
        font-size: 28px;
        font-weight: 400;
        text-align: center;
        .box-label {
          color: rgb(232, 51, 36);
        }
      }
      .box-notice {
        margin-top: 16px;
        color: #888888;
        font-size: 24px;
        font-weight: 400;
      }
    }
  }

  /deep/ .van-checkbox {
    align-items: stretch;
  }
  /deep/ .van-popup {
    z-index: 99999 !important;
  }
  .black-theme {
    .darkClose, .darkOpen {
      display: block !important;
    }
    .title {
      color: #FFFFFF;
    }
    .tips {
      background: #14151D !important;
      color: white !important;
    }
    .text {
      color: white !important;
    }
    .signature {
      .title {
        color: #FFFFFF;
      }
      .text {
        color: #9D9D9F !important;
      }
      .box {
        border: 1px dashed rgba(255,255,255,0.45);
        background: white;
      }
    }
    .van-dialog {
      background: #1B1C24 !important;
      /deep/ .van-dialog__header {
        color: white;
      }
      /deep/ .van-dialog__message {
        color: white;
      }
      /deep/ .van-button__content {
        color: white;
      }
      /deep/ .van-button--default {
        background: #1B1C24 !important;
      }
      /deep/ .box-row {
        color: white !important;
      }
    }
  }
  // icon
  .img-icon{
    width: 36px;
    height: 36px;
  }

  .check-password-dialog{
    padding: 56px;
    width: 488px;
    ::v-deep {
      .van-dialog__header{
        padding-top: 0;
        font-size: 36px;
        font-weight: 500;
        color: #17161C;
      }
      .van-dialog__content{
        margin-top: 32px;
      }
      .verifyLoginPassword{
        margin: 0;
      }
      .van-dialog__footer{
        margin-top: 48px;
        padding: 0 !important;
        &:after{
          display: none !important;
        }
        .van-button{
          background: rgba(15,15,47,0.04);
          border-radius: 100px;
          color: #17161C;
          height: 100px;
          font-size: 28px;
          & + .van-button{
            margin-left: 24px;
            background: #17161C;
            color: #fff;
            font-weight: 500;
            &:before,&:after{
              display: none;
            }
          }
          .van-button__text {
            font-weight: 500;
          }
        }
      }
    }
  }
  .black-theme{
    .check-password-dialog{
      ::v-deep {
        .van-dialog__footer{
          .van-button{
            color: #fff;
            background: #8E92A3 !important;
            & + .van-button{
              background: #377CFB !important;
            }
          }
        }
      }
    }
  }
  .white-theme {
    .lightClose, .lightOpen {
      display: block !important;
    }
  }
  </style>
